import { c as _c } from "react/compiler-runtime";
import useSWR from "swr";
import { useRef, useEffect, useCallback } from "react";
export default function useScrollToBottom() {
  const $ = _c(17);
  const containerRef = useRef(null);
  const endRef = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      fallbackData: false
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: t1,
    mutate: setIsAtBottom
  } = useSWR("messages:is-at-bottom", null, t0);
  const isAtBottom = t1 === undefined ? false : t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fallbackData: false
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: t3,
    mutate: setScrollBehavior
  } = useSWR("messages:should-scroll", null, t2);
  const scrollBehavior = t3 === undefined ? false : t3;
  let t4;
  let t5;
  if ($[2] !== scrollBehavior || $[3] !== setScrollBehavior) {
    t4 = () => {
      if (scrollBehavior) {
        endRef.current?.scrollIntoView({
          behavior: scrollBehavior
        });
        setScrollBehavior(false);
      }
    };
    t5 = [setScrollBehavior, scrollBehavior];
    $[2] = scrollBehavior;
    $[3] = setScrollBehavior;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] !== setScrollBehavior) {
    t6 = t7 => {
      const scrollBehavior_0 = t7 === undefined ? "smooth" : t7;
      setScrollBehavior(scrollBehavior_0);
    };
    $[6] = setScrollBehavior;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const scrollToBottom = t6;
  let t7;
  if ($[8] !== setIsAtBottom) {
    t7 = function onViewportEnter() {
      setIsAtBottom(true);
    };
    $[8] = setIsAtBottom;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onViewportEnter = t7;
  let t8;
  if ($[10] !== setIsAtBottom) {
    t8 = function onViewportLeave() {
      setIsAtBottom(false);
    };
    $[10] = setIsAtBottom;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const onViewportLeave = t8;
  let t9;
  if ($[12] !== isAtBottom || $[13] !== onViewportEnter || $[14] !== onViewportLeave || $[15] !== scrollToBottom) {
    t9 = {
      containerRef,
      endRef,
      isAtBottom,
      scrollToBottom,
      onViewportEnter,
      onViewportLeave
    };
    $[12] = isAtBottom;
    $[13] = onViewportEnter;
    $[14] = onViewportLeave;
    $[15] = scrollToBottom;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}